import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-delaware-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./delaware-state-form.component.html",
  styleUrl: "./delaware-state-form.component.scss",
})
export class DelawareStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
